import React, { useEffect, useContext, useState } from "react";
import "./styles/AssociateFieldset.scss";
import FieldsetSelect from "../FieldsetSelect/FieldsetSelect";
import DeleteIcon from "../VectorIcons/DeleteIcon";
import AppContext from "../../context/appContext";
import AsyncSelect from "react-select/async";
import AsyncLoading from "../../components/AsyncLoading/AsyncLoading";
import { useContentSearchLoader } from "../../hooks/useContentSearchLoader";
import { ASSOCIABLE_PROJECT_TYPES } from "../../shared/constants/contentType";
import Option from "./Option/Option";

const AssociateFieldset = (props) => {
  const {
    id,
    indexPosition,
    removeField,
    handleChangeCreatable,
    projectsLength,
    handleChangeAssociationType,
    endpoint,
    thesaurusNumber,
    data,
    selected,
    value,
    defaultValue,
    showPlaceholder,
  } = props;

  const initialStateProjects = { create: [], load: [] };
  const context = useContext(AppContext);
  const [stateOptions, setStateOptions] = useState(initialStateProjects);

  const handleChangeAssociation = (ev) => {
    const id = ev.nativeEvent.target.selectedIndex;
    const idText = ev.nativeEvent.target[id].text;
    handleChangeAssociationType(ev.target.value, indexPosition, idText);
  };

  useEffect(() => {
    context.getTypeThesaurus(thesaurusNumber, endpoint);
    // eslint-disable-next-line
  }, []);

  const searchChipsAdapterProjects = useContentSearchLoader({
    types: ASSOCIABLE_PROJECT_TYPES,
    excludeId: id,
  });

  const handleChangeCreateProjects = (items, actionMeta) => {
    handleChangeCreatable(items, actionMeta.action, indexPosition);
    setStateOptions({ ...stateOptions, create: items || [] });
  };

  return (
    <div
      className={`associateFieldset ${
        projectsLength > 1 ? "showDeleteIcon" : ""
      }`}
      style={{ zIndex: 15 - indexPosition }}
    >
      <FieldsetSelect
        data={data}
        placeholder={showPlaceholder ? "Selecione" : ""}
        handleChange={handleChangeAssociation}
        selected={selected}
      />

      <AsyncSelect
        isMulti
        className="reactSelect"
        classNamePrefix="reactSelect"
        value={value}
        defaultValue={defaultValue}
        loadOptions={searchChipsAdapterProjects}
        onChange={handleChangeCreateProjects}
        components={{
          LoadingIndicator: () => <AsyncLoading />,
          Option,
        }}
        noOptionsMessage={() => "Nenhum item encontrado"}
        loadingMessage={() => "Carregando..."}
        placeholder="Selecione"
      />

      {projectsLength > 1 && (
        <div className="deleteIcon" onClick={() => removeField(indexPosition)}>
          <DeleteIcon />
        </div>
      )}
    </div>
  );
};

export default AssociateFieldset;
